export enum LegalAgreementType {
    DISCLAIMER = "descargoResponsabilidad",
    POLITICA_PRIVACIDAD = "politicaPrivacidad",
    TERMINOS_CONDICIONES = "terminosCondiciones",
}